import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

/**
 * Wraps the entire /admin route tree. A crash in an admin page (bad response
 * shape, a rendering bug) must never take down the rest of the SPA — this
 * boundary contains it to the admin section only. React only supports error
 * boundaries as class components.
 */
export default class AdminErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-rd-bg text-rd-text flex items-center justify-center p-8">
          <div className="max-w-md text-center">
            <h1 className="font-sora text-lg text-rd-text mb-2">Admin panel error</h1>
            <p className="font-dmSans text-sm text-rd-muted mb-4">
              Something went wrong rendering this page. This is isolated to the admin
              section — the rest of ReputeDesk is unaffected.
            </p>
            <button
              type="button"
              onClick={() => this.setState({ error: null })}
              className="px-4 py-2 rounded-md bg-rd-surface2 text-rd-text text-sm font-dmSans hover:bg-white/10"
            >
              Try again
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
